import React, { useState, useRef, useEffect } from 'react';
import Peer from 'peerjs';

const Viewer = () => {
  const [peerId, setPeerId] = useState(null);// 고유한 ID 할당
  const [remotePeerId, setRemotePeerId] = useState("");
  const peerRef = useRef(null);
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const localStreamRef = useRef(null);
  const [videoOn, setVideoOn] = useState(true);
  const [screenStream, setScreenStream] = useState(null);

  useEffect(() => {
    // 기존 Peer가 있다면 삭제
    if (window.existingPeer) {
      console.log("🔄 기존 Peer 제거");
      window.existingPeer.destroy();
    }
    
    // PeerJS 연결 설정
    // 1️⃣ Peer ID를 랜덤으로 생성 (중복 방지)
    const uniqueId = `${Math.floor(Math.random() * 10000)}`;
    const peer = new Peer(uniqueId, {
      host: process.env.REACT_APP_DOMAIN, // ⚠️ 로컬 IP 사용
      port: 4000,             // HTTPS 포트
      path: '/peerjs',
      secure: true,  
    });

    peerRef.current = peer;

    peer.on('open', (id) => {
      console.log(`📡 Viewer Ready! ID: ${id}`);
      setPeerId(id);
    });

    peer.on('call', (call) => {
      console.log('📞 Incoming call from Streamer...');
      call.answer(localStreamRef.current); // 내 stream으로 응답
      
      call.on("stream", (remoteStream) => {
        remoteVideoRef.current.srcObject = remoteStream;
        remoteVideoRef.current.play().catch(console.error);
      });
    });

    // 오류 처리
    // peerRef.current.on('error', (err) => console.error('🚨 PeerJS 오류:', err));
    peer.on("error", (err) => {
      console.error("🚨 PeerJS 오류:", err);
    });

    return () => {
      peer.destroy();
    };
  }, []);

  const startCall = async () => {
    if (!remotePeerId) {
      alert("상대방의 Peer ID를 입력하세요.");
      return;
    }

    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true,
    });
    localStreamRef.current = stream;
    localVideoRef.current.srcObject = stream;
    localVideoRef.current.muted = true;
    await localVideoRef.current.play();

    const call = peerRef.current.call(remotePeerId, stream);

    call.on("stream", (remoteStream) => {
      remoteVideoRef.current.srcObject = remoteStream;
      remoteVideoRef.current.play().catch(console.error);
    });
  };

  const toggleVideo = () => {
    const videoTrack = localStreamRef.current.getVideoTracks()[0];
    videoTrack.enabled = !videoTrack.enabled;
    setVideoOn(videoTrack.enabled);
  };

  const startScreenShare = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
        audio: true,
      });
  
      setScreenStream(stream);
  
      // 예시: 상대방에게 공유
      const call = peerRef.current.call(remotePeerId, stream);
      // ...
    } catch (err) {
      console.error("🚨 화면 공유 실패:", err);
    }
  };
  
  const stopScreenShare = () => {
    if (screenStream) {
      screenStream.getTracks().forEach(track => track.stop());
      setScreenStream(null);
    }
  };

  return (
    <div>
      <h2>💻 뷰어 화면</h2>
      <p>Viewer ID: {peerId}</p>
      <p>송출 화면에서 제공하는 Streamer ID를 입력하고 통화 시작버튼을 눌러주시기 바랍니다.</p>
      <input
        placeholder="Streamer ID"
        value={remotePeerId}
        onChange={(e) => setRemotePeerId(e.target.value)}
      />
      <button onClick={startCall}>통화 시작</button>
      <div style={{display:"flex"}}>
        <div style={{padding:"5px"}}>
          <h3>🎥 내 화면</h3>
          <video ref={localVideoRef} autoPlay playsInline controls muted style={{ width: "300px",
            // display: videoOn ? "none" : "block", // 🔥 숨기기
           }} />
            <br/><button onClick={toggleVideo}>
              {videoOn ? "📴 내 영상 끄기" : "📹 내 영상 켜기"}
            </button>
            {/* <button onClick={screenStream ? stopScreenShare : startScreenShare}>
              {screenStream ? "🛑 화면 공유 중단" : "🖥 화면 공유 시작"}
            </button> */}
        </div>
        <div style={{padding:"5px"}}>
          <h3>👀 상대 화면</h3>
          <video ref={remoteVideoRef} autoPlay playsInline controls style={{ width: "300px" }} />
        </div>
      </div>
      <p>송출 주소 : https://{process.env.REACT_APP_DOMAIN}/streamer</p>
      {/* <p>송출화면에서 '{peerId}'를 입력하고 통화 시작버튼을 눌러주시기 바랍니다.</p>
      <p>송출화면이 연결되면 재생버튼을 클릭하여 재생해주시기 바랍니다.</p> */}
    </div>
  );
};

export default Viewer;